// import React, { useState, useEffect } from "react";
// import {
//   Box,
//   Typography,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   Paper,
//   Chip,
//   IconButton,
//   TablePagination,
//   Tooltip,
//   Menu,
//   MenuItem,
//   ListItemIcon,
//   ListItemText,
//   CircularProgress,
//   useTheme,
//   useMediaQuery,
//   Card,
//   CardContent,
//   Stack,
//   Divider,
//   Link,
//   Tabs,
//   Tab,
// } from "@mui/material";
// import {
//   Visibility,
//   Add,
//   MoreVert,
//   PersonAdd,
//   Group,
//   Download,
// } from "@mui/icons-material";
// import axios from "axios";
// import { BASE_URL } from "../../../../services/configUrls";
// import AddFacultyModal from "./AddFacultyModal";
// import AddNewFacultyModal from "./AddNewFacultyModal";
// import ViewFacultyModal from "./ViewFacultyModal";
// import ViewCoordinatorsModal from "./ViewCoordinatormodal";
// import RequestFDP from "../RequestFDP";
// import InfoOutlined from "@mui/icons-material/InfoOutlined";

// const FacultyEventTable = ({ onBookingClick, eventType = "fdp", refreshKey }) => {
//   const [page, setPage] = useState(0);
//   const [rowsPerPage, setRowsPerPage] = useState(10);
//   const [anchorEl, setAnchorEl] = useState(null);
//   const [selectedBooking, setSelectedBooking] = useState(null);
//   const [bookings, setBookings] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [tabValue, setTabValue] = useState(0); // 0 for Hosted, 1 for Participated, 2 for Upcoming, 3 for fdp slots
//   const [fdpSlotsVisible, setFdpSlotsVisible] = useState(false);
//   const [visibilityLoading, setVisibilityLoading] = useState(true);


//   // Add Faculty Modal State
//   const [addFacultyModalOpen, setAddFacultyModalOpen] = useState(false);
//   const [selectedBookslotId, setSelectedBookslotId] = useState(null);

//   // Add New Faculty Modal State (for Nominations Open/Started events)
//   const [addNewFacultyModalOpen, setAddNewFacultyModalOpen] = useState(false);
//   const [selectedBookslotIdForNew, setSelectedBookslotIdForNew] =
//     useState(null);

//   // View Faculty Modal State
//   const [viewFacultyModalOpen, setViewFacultyModalOpen] = useState(false);
//   const [selectedBookslotIdForView, setSelectedBookslotIdForView] =
//     useState(null);

//   // View Coordinators Modal State
//   const [viewCoordinatorsModalOpen, setViewCoordinatorsModalOpen] =
//     useState(false);
//   const [selectedCoordinators, setSelectedCoordinators] = useState([]);
//   const [selectedCoordinatorBookslotId, setSelectedCoordinatorBookslotId] =
//     useState(null);

//   const theme = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
//   const isTablet = useMediaQuery(theme.breakpoints.down("md"));

//   const colors = {
//     fullyBooked: "#2196F3",
//     partiallyBooked: "#9E9E9E",
//     upcoming: "#4CAF50",
//     started: "#FF9800",
//     closed: "#9E9E9E",
//     nominationsNotOpen: "#FF5722",
//   };

//   // Fetch bookings from API
//   useEffect(() => {
//     console.log("REFRESH KEY TRIGGERED", refreshKey);
//     fetchBookings();
//   }, [refreshKey]);

//   const fetchBookings = async () => {
//     try {
//       setLoading(true);
//       const response = await axios.get(`${BASE_URL}/event/all-bookings`, {
//         headers: {
//           "Content-Type": "application/json",
//           Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
//         },
//       });

//       const { fdp = [], edp = [] } = response.data;

//       // Combine FDP and EDP bookings into one array
//       const combinedBookings = [...fdp, ...edp];

//       setBookings(combinedBookings);
//       setError(null);
//     } catch (err) {
//       setError("Failed to fetch bookings");
//       console.error("Error fetching bookings:", err);
//     } finally {
//       setLoading(false);
//     }
//   };

  
//   useEffect(() => {
//     const fetchFdpVisibility = async () => {
//       try {
//         const res = await axios.get(
//           `${BASE_URL}/event/institute/fdp-slots-visibility`,
//           {
//             headers: {
//               "Content-Type": "application/json",
//               Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
//             },
//           }
//         );

//         // visible = 1 → show, else hide
//         setFdpSlotsVisible(res.data?.visible === 1);
//       } catch (err) {
//         console.error("Failed to fetch FDP slots visibility", err);
//         setFdpSlotsVisible(false); // fail-safe
//       } finally {
//         setVisibilityLoading(false);
//       }
//     };

//     fetchFdpVisibility();
//   }, []);

//   const formatDate = (dateStr) => {
//     return new Date(dateStr).toLocaleDateString("en-US", {
//       year: "numeric",
//       month: "short",
//       day: "numeric",
//     });
//   };

//   const getDateRange = (startDate, endDate) => {
//     const start = formatDate(startDate);
//     const end = formatDate(endDate);
//     return start === end ? start : `${start} - ${end}`;
//   };

//   const isBookingFullyBooked = (booking) => {
//     return (
//       booking.faculty_limit > 0 &&
//       booking.faculty_added >= booking.faculty_limit
//     );
//   };

//   const isBookingPartiallyBooked = (booking) => {
//     const hasParticipants = booking.faculty_added > 0;
//     return hasParticipants && !isBookingFullyBooked(booking);
//   };

//   const getStatusChip = (booking) => {
//     const getEventStatusChip = () => {
//       if (!booking.event_status) return null;

//       const statusConfig = {
//         Upcoming: { color: colors.upcoming, label: "Upcoming" },
//         Started: { color: colors.started, label: "Started" },
//         Closed: { color: colors.closed, label: "Closed" },
//         "Nominations Not Open": {
//           color: colors.nominationsNotOpen,
//           label: "Nominations Not Open",
//         },
//       };

//       const config = statusConfig[booking.event_status] || {
//         color: colors.closed,
//         label: booking.event_status,
//       };

//       return (
//         <Chip
//           label={config.label}
//           size="small"
//           sx={{
//             backgroundColor: config.color,
//             color: "white",
//             fontWeight: 500,
//             fontSize: "0.7rem",
//           }}
//         />
//       );
//     };

//     const getBookingStatusChip = () => {
//       if (
//         booking.event_status === "Closed" ||
//         booking.event_status === "Nominations Not Open"
//       ) {
//         return null;
//       }
//       if (
//         booking.event_status === "Canceled" ||
//         booking.event_status === "Cancelled"
//       ) {
//         return null;
//       }

//       if (isBookingFullyBooked(booking)) {
//         return null;
//       } else if (isBookingPartiallyBooked(booking)) {
//         return null;
//       } else {
//         return null;
//       }
//     };

//     return (
//       <Box display="flex" gap={0.5} flexWrap="wrap">
//         {getEventStatusChip()}
//         {getBookingStatusChip()}
//       </Box>
//     );
//   };

//   const handleMenuOpen = (event, booking) => {
//     event.stopPropagation();
//     setAnchorEl(event.currentTarget);
//     setSelectedBooking(booking);
//   };

//   const handleMenuClose = () => {
//     setAnchorEl(null);
//     setSelectedBooking(null);
//   };

//   const handleDownloadCertificate = async (bookslotId) => {
//     try {
//       const response = await axios.get(
//         `${BASE_URL}/event/fdp-institute-certificate/${bookslotId}`,
//         {
//           headers: {
//             "Content-Type": "application/json",
//             Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
//           },
//         }
//       );

//       if (response.data && response.data.certificate_base64) {
//         // Convert base64 to blob and download
//         const base64Data = response.data.certificate_base64;
//         const byteCharacters = atob(base64Data);
//         const byteNumbers = new Array(byteCharacters.length);

//         for (let i = 0; i < byteCharacters.length; i++) {
//           byteNumbers[i] = byteCharacters.charCodeAt(i);
//         }

//         const byteArray = new Uint8Array(byteNumbers);
//         const blob = new Blob([byteArray], { type: "application/pdf" });

//         // Create download link
//         const url = window.URL.createObjectURL(blob);
//         const link = document.createElement("a");
//         link.href = url;
//         link.download = `certificate_${bookslotId}.pdf`;
//         document.body.appendChild(link);
//         link.click();
//         document.body.removeChild(link);
//         window.URL.revokeObjectURL(url);
//       }
//     } catch (err) {
//       console.error("Error downloading certificate:", err);
//       alert("Failed to download certificate. Please try again.");
//     }
//   };

//   const handleMenuItemClick = (action) => {
//     if (action === "add") {
//       // Open existing Add Faculty Modal
//       setSelectedBookslotId(selectedBooking.bookslot_id);
//       setAddFacultyModalOpen(true);
//       handleMenuClose();
//     } else if (action === "addNew") {
//       // Open new Add Faculty Modal for Nominations Open/Started
//       setSelectedBookslotIdForNew(selectedBooking.bookslot_id);
//       setAddNewFacultyModalOpen(true);
//       handleMenuClose();
//     } else if (action === "view") {
//       // Open View Faculty Modal
//       setSelectedBookslotIdForView(selectedBooking.bookslot_id);
//       setViewFacultyModalOpen(true);
//       handleMenuClose();
//     } else if (action === "downloadCertificate") {
//       // Download certificate
//       handleDownloadCertificate(selectedBooking.bookslot_id);
//       handleMenuClose();
//     } else if (selectedBooking && onBookingClick) {
//       onBookingClick(selectedBooking, action);
//       handleMenuClose();
//     }
//   };

//   const handleViewCoordinators = (e, coordinators, bookslotId) => {
//     e.stopPropagation();
//     setSelectedCoordinators(coordinators || []);
//     setSelectedCoordinatorBookslotId(bookslotId);
//     setViewCoordinatorsModalOpen(true);
//   };

//   const handleAddFacultySuccess = () => {
//     // Refresh bookings after successfully adding faculty
//     fetchBookings();
//   };

//   // Helper function to check if faculty can be added
//   const canAddFaculty = (booking) => {
//     // Allow adding faculty only when event status is "Nominations Open" or "Started"
//     const isNominationsOpen = booking.event_status === "Upcoming";
//     const isStarted = booking.event_status === "Started";
//     const isNotFullyBooked = !isBookingFullyBooked(booking);

//     return (isNominationsOpen || isStarted) && isNotFullyBooked;
//   };

//   const handleChangePage = (event, newPage) => {
//     setPage(newPage);
//   };

//   const handleChangeRowsPerPage = (event) => {
//     setRowsPerPage(parseInt(event.target.value, 10));
//     setPage(0);
//   };

//   const handleTabChange = (event, newValue) => {
//     setTabValue(newValue);
//     setPage(0); // Reset to first page when switching tabs
//   };

//   // Filter bookings by event type
//   const filteredByEventType = bookings.filter(
//     (booking) => booking.event_type === eventType
//   );

//   // Filter by hosted/participated/upcoming for FDP events using API boolean flags
//   const filteredByHosting =
//     eventType === "fdp"
//       ? filteredByEventType.filter((booking) => {
//           if (tabValue === 0) {
//             // Host: show all events hosted by your institute
//             return booking.is_hosted === true;
//           } else if (tabValue === 1) {
//             // Nominate: events your faculty are participating in
//             return booking.is_participated === true;
//           } else if (tabValue === 2) {
//             // Participate: only events NOT hosted by you and NOT already participated
//             return (
//               booking.is_upcoming === true &&
//               booking.is_hosted !== true &&
//               booking.is_participated !== true
//             );
//           }
//         })
//       : filteredByEventType;

//   // Paginate bookings
//   const paginatedBookings = filteredByHosting.slice(
//     page * rowsPerPage,
//     page * rowsPerPage + rowsPerPage
//   );

//   const getActionButtons = (booking) => {
//     return (
//       <Box display="flex" gap={1} alignItems="center">
//         <Tooltip title="More Actions">
//           <IconButton
//             size="small"
//             onClick={(e) => handleMenuOpen(e, booking)}
//             sx={{
//               color: "#1976d2",
//               "&:hover": {
//                 backgroundColor: "#e3f2fd",
//               },
//             }}
//           >
//             <MoreVert />
//           </IconButton>
//         </Tooltip>
//       </Box>
//     );
//   };

//   const MobileCardView = ({ booking, showTrainer }) => {
//     return (
//       <Card
//         sx={{
//           mb: 2,
//           borderRadius: 3,
//           boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
//           border: "1px solid #e0e7ff",
//           "&:hover": {
//             boxShadow: "0 4px 12px rgba(0,0,0,0.12)",
//           },
//         }}
//       >
//         <CardContent>
//           <Stack spacing={2}>
//             <Box
//               display="flex"
//               justifyContent="space-between"
//               alignItems="start"
//             >
//               <Tooltip title={booking.institute_name} arrow>
//                 <Typography
//                   variant="h6"
//                   fontWeight={600}
//                   sx={{
//                     flex: 1,
//                     overflow: "hidden",
//                     textOverflow: "ellipsis",
//                     whiteSpace: "nowrap",
//                     mr: 1,
//                   }}
//                 >
//                   {booking.institute_name}
//                 </Typography>
//               </Tooltip>
//               <IconButton
//                 size="small"
//                 onClick={(e) => handleMenuOpen(e, booking)}
//               >
//                 <MoreVert />
//               </IconButton>
//             </Box>

//             <Divider />

//             <Box>
//               <Typography variant="caption" color="text.secondary">
//                 Domain
//               </Typography>
//               <Tooltip title={booking.domain_name} arrow>
//                 <Typography
//                   variant="body2"
//                   sx={{
//                     overflow: "hidden",
//                     textOverflow: "ellipsis",
//                     whiteSpace: "nowrap",
//                     maxWidth: "100%",
//                   }}
//                 >
//                   {booking.domain_name}
//                 </Typography>
//               </Tooltip>
//             </Box>

//             <Box>
//               <Typography variant="caption" color="text.secondary">
//                 Date Range
//               </Typography>
//               <Typography variant="body2">
//                 {getDateRange(booking.start_date, booking.end_date)}
//               </Typography>
//             </Box>

//             {showTrainer && (
//               <Box>
//                 <Typography variant="caption" color="text.secondary">
//                   Trainer
//                 </Typography>
//                 <Typography variant="body2" fontWeight={500}>
//                   {booking.trainer_name}
//                 </Typography>
//                 <Typography variant="caption" color="text.secondary">
//                   {booking.trainer_email}
//                 </Typography>
//               </Box>
//             )}

//             <Box>
//               <Typography variant="caption" color="text.secondary">
//                 Faculty
//               </Typography>
//               <Typography variant="body2">
//                 {booking.faculty_added}
//                 {booking.faculty_limit > 0 ? ` / ${booking.faculty_limit}` : ""}
//               </Typography>
//             </Box>

//             {/* Show coordinators only for FDP */}
//             {eventType === "fdp" &&
//               booking.coordinators &&
//               booking.coordinators.length > 0 && (
//                 <Box>
//                   <Typography variant="caption" color="text.secondary">
//                     Coordinators
//                   </Typography>
//                   <Link
//                     component="button"
//                     variant="body2"
//                     onClick={(e) =>
//                       handleViewCoordinators(
//                         e,
//                         booking.coordinators,
//                         booking.bookslot_id
//                       )
//                     }
//                     sx={{
//                       display: "flex",
//                       alignItems: "center",
//                       gap: 0.5,
//                       mt: 0.5,
//                       textDecoration: "none",
//                       color: "#1976d2",
//                       "&:hover": {
//                         textDecoration: "underline",
//                       },
//                     }}
//                   >
//                     <Group fontSize="small" />
//                     View Details ({booking.coordinators?.length || 0})
//                   </Link>
//                 </Box>
//               )}

//             <Box>{getStatusChip(booking)}</Box>
//           </Stack>
//         </CardContent>
//       </Card>
//     );
//   };

//   if (loading) {
//     return (
//       <Box
//         display="flex"
//         justifyContent="center"
//         alignItems="center"
//         minHeight="400px"
//       >
//         <CircularProgress />
//       </Box>
//     );
//   }

//   if (error) {
//     return (
//       <Box
//         display="flex"
//         justifyContent="center"
//         alignItems="center"
//         minHeight="400px"
//       >
//         <Typography color="error">{error}</Typography>
//       </Box>
//     );
//   }

//   // Determine if we should show trainer column
//   // Only show trainer for FDP events in "Hosted by Us" tab (tabValue === 0)
//   const showTrainer = eventType === "fdp" && tabValue === 0;

//   return (
//     <Box sx={{ px: { xs: 2, sm: 3, md: 4 } }}>
//       {/* Tabs for FDP event type */}
//       {eventType === "fdp" && (
//         <Box sx={{ borderBottom: 1, borderColor: "divider", mb: 3 }}>
//           <Tabs
//             value={tabValue}
//             onChange={handleTabChange}
//             sx={{
//               "& .MuiTab-root": {
//                 textTransform: "none",
//                 fontSize: "1rem",
//                 fontWeight: 500,
//               },
//             }}
//           >
//             <Tab label={
//     <Box display="flex" alignItems="center" gap={0.5}>
//       <Typography
//         component="span"
//         sx={{
//           fontSize: "1rem",
//           fontWeight: 500,
//         }}
//       >
//         Host
//       </Typography>

//       <Tooltip
//         title="View Hosted FDPs of your institutes and can nominate your faculties."
//         arrow
//         placement="top"
//       >
//         <InfoOutlined
//           fontSize="small"
//           onClick={(e) => e.stopPropagation()}
//           sx={{
//             color: "inherit",          // 🔥 THIS IS THE KEY
//             cursor: "pointer",
//             ml: 0.25,
//             "&:hover": {
//               color: "primary.main",
//             },
//           }}
//         />
//       </Tooltip>
//     </Box>
//   }
//   sx={{
//     minHeight: 48,
//     "&.Mui-selected": {
//       color: "primary.main",        // active tab color
//       fontWeight: 600,
//     },
//   }}/>
//             <Tab label={
//     <Box display="flex" alignItems="center" gap={0.5}>
//       <Typography
//         component="span"
//         sx={{
//           fontSize: "1rem",
//           fontWeight: 500,
//         }}
//       >
//         Nominate
//       </Typography>

//       <Tooltip
//         title="View fdps to which your faculties nominated those fdps hosted by other institutes."
//         arrow
//         placement="top"
//       >
//         <InfoOutlined
//           fontSize="small"
//           onClick={(e) => e.stopPropagation()}
//           sx={{
//             color: "inherit",          // 🔥 THIS IS THE KEY
//             cursor: "pointer",
//             ml: 0.25,
//             "&:hover": {
//               color: "primary.main",
//             },
//           }}
//         />
//       </Tooltip>
//     </Box>
//   }
//   sx={{
//     minHeight: 48,
//     "&.Mui-selected": {
//       color: "primary.main",        // active tab color
//       fontWeight: 600,
//     },
//   }} />
//             <Tab label={
//     <Box display="flex" alignItems="center" gap={0.5}>
//       <Typography
//         component="span"
//         sx={{
//           fontSize: "1rem",
//           fontWeight: 500,
//         }}
//       >
//         Participate
//       </Typography>

//       <Tooltip
//         title="View FDPs hosting by other institutes and can nominate your faculties."
//         arrow
//         placement="top"
//       >
//         <InfoOutlined
//           fontSize="small"
//           onClick={(e) => e.stopPropagation()}
//           sx={{
//             color: "inherit",          // 🔥 THIS IS THE KEY
//             cursor: "pointer",
//             ml: 0.25,
//             "&:hover": {
//               color: "primary.main",
//             },
//           }}
//         />
//       </Tooltip>
//     </Box>
//   }
//   sx={{
//     minHeight: 48,
//     "&.Mui-selected": {
//       color: "primary.main",        // active tab color
//       fontWeight: 600,
//     },
//   }}/>
//   {fdpSlotsVisible && (
//   <Tab
//     label={
//       <Box display="flex" alignItems="center" gap={0.5}>
//         <Typography
//           component="span"
//           sx={{ fontSize: "1rem", fontWeight: 500 }}
//         >
//           FDP Slots
//         </Typography>

//         <Tooltip
//           title="View available FDP slots to host & submit interest under Available and also can view Booked slots of all institutes, past submitted FDP interest of all institutes under Archive."
//           arrow
//         >
//           <InfoOutlined
//             fontSize="small"
//             onClick={(e) => e.stopPropagation()}
//             sx={{
//               color: "inherit",
//               cursor: "pointer",
//               ml: 0.25,
//               "&:hover": { color: "primary.main" },
//             }}
//           />
//         </Tooltip>
//       </Box>
//     }
//     sx={{
//       minHeight: 48,
//       "&.Mui-selected": {
//         color: "primary.main",
//         fontWeight: 600,
//       },
//     }}
//   />
// )}
//           </Tabs>
//         </Box>
//       )}

//       {tabValue !== 3 && (
//         <Box
//         display="flex"
//         justifyContent="space-between"
//         alignItems="center"
//         mb={3}
//       >
//         <Typography variant={isMobile ? "body1" : "h6"} color="text.secondary">
//           {filteredByHosting.length} Programs
//         </Typography>
//       </Box>)}

//       {tabValue === 3 && eventType === "fdp" && fdpSlotsVisible ? (
//   <RequestFDP />
// ) :isMobile || isTablet ? (
//         // Mobile/Tablet Card View
//         <Box>
//           {paginatedBookings.map((booking, index) => (
//             <MobileCardView
//               key={`${booking.bookslot_id}-${index}`}
//               booking={booking}
//               showTrainer={showTrainer}
//             />
//           ))}
//           {paginatedBookings.length === 0 && (
//             <Card sx={{ textAlign: "center", py: 4 }}>
//               <Typography color="text.secondary">
//                 No programs found matching your filters
//               </Typography>
//             </Card>
//           )}
//           <TablePagination
//             rowsPerPageOptions={[5, 10, 25, 50]}
//             component="div"
//             count={filteredByHosting.length}
//             rowsPerPage={rowsPerPage}
//             page={page}
//             onPageChange={handleChangePage}
//             onRowsPerPageChange={handleChangeRowsPerPage}
//             sx={{ mt: 2 }}
//           />
//         </Box>
//       ) : (
//         // Desktop Table View
//         <TableContainer
//           component={Paper}
//           sx={{
//             borderRadius: 3,
//             boxShadow: "0 4px 16px rgba(0,0,0,0.08)",
//             border: "1px solid #e0e7ff",
//             overflowX: "auto",
//           }}
//         >
//           <Table>
//             <TableHead>
//               <TableRow sx={{ backgroundColor: "#f8fafc" }}>
//                 {/* Show Institute column only for FDP */}
//                 {eventType === "fdp" && (
//                   <TableCell
//                     sx={{ fontWeight: 600, fontSize: "0.8rem", py: 1.5 }}
//                   >
//                     Hosted Institute
//                   </TableCell>
//                 )}
//                 <TableCell
//                   sx={{ fontWeight: 600, fontSize: "0.8rem", py: 1.5 }}
//                 >
//                   Domain
//                 </TableCell>
//                 <TableCell
//                   sx={{ fontWeight: 600, fontSize: "0.8rem", py: 1.5 }}
//                 >
//                   Date Range
//                 </TableCell>
//                 {/* Show Trainer column conditionally */}
//                 {showTrainer && (
//                   <TableCell
//                     sx={{ fontWeight: 600, fontSize: "0.8rem", py: 1.5 }}
//                   >
//                     Trainer
//                   </TableCell>
//                 )}
//                 <TableCell
//                   sx={{ fontWeight: 600, fontSize: "0.8rem", py: 1.5 }}
//                 >
//                   Faculty
//                 </TableCell>
//                 <TableCell
//                   sx={{ fontWeight: 600, fontSize: "0.8rem", py: 1.5 }}
//                 >
//                   Status
//                 </TableCell>
//                 <TableCell
//                   sx={{ fontWeight: 600, fontSize: "0.8rem", py: 1.5 }}
//                 >
//                   Actions
//                 </TableCell>
//               </TableRow>
//             </TableHead>
//             <TableBody>
//               {paginatedBookings.map((booking, index) => (
//                 <TableRow
//                   key={`${booking.bookslot_id}-${index}`}
//                   sx={{
//                     "&:hover": {
//                       backgroundColor: "#f8fafc",
//                     },
//                     cursor: "pointer",
//                   }}
//                   onClick={() => onBookingClick && onBookingClick(booking)}
//                 >
//                   {/* Show Institute cell only for FDP */}
//                   {eventType === "fdp" && (
//                     <TableCell sx={{ py: 1.5 }}>
//                       <Tooltip title={booking.institute_name} arrow>
//                         <Typography
//                           variant="body2"
//                           sx={{
//                             maxWidth: 200,
//                             overflow: "hidden",
//                             textOverflow: "ellipsis",
//                             whiteSpace: "nowrap",
//                             fontSize: "0.85rem",
//                           }}
//                         >
//                           {booking.institute_name}
//                         </Typography>
//                       </Tooltip>
//                     </TableCell>
//                   )}
//                   <TableCell sx={{ py: 1.5 }}>
//                     <Tooltip title={booking.domain_name} arrow>
//                       <Typography
//                         variant="body2"
//                         sx={{
//                           maxWidth: 250,
//                           overflow: "hidden",
//                           textOverflow: "ellipsis",
//                           whiteSpace: "nowrap",
//                           fontSize: "0.85rem",
//                         }}
//                       >
//                         {booking.domain_name}
//                       </Typography>
//                     </Tooltip>
//                   </TableCell>
//                   <TableCell sx={{ py: 1.5 }}>
//                     <Typography variant="body2" sx={{ fontSize: "0.85rem" }}>
//                       {getDateRange(booking.start_date, booking.end_date)}
//                     </Typography>
//                   </TableCell>
//                   {/* Show Trainer cell conditionally */}
//                   {showTrainer && (
//                     <TableCell sx={{ py: 1.5 }}>
//                       <Box>
//                         <Typography
//                           variant="body2"
//                           fontWeight={500}
//                           sx={{ fontSize: "0.85rem" }}
//                         >
//                           {booking.trainer_name}
//                         </Typography>
//                         <Typography
//                           variant="caption"
//                           color="text.secondary"
//                           sx={{ fontSize: "0.75rem" }}
//                         >
//                           {booking.trainer_email}
//                         </Typography>
//                       </Box>
//                     </TableCell>
//                   )}
//                   <TableCell sx={{ py: 1.5 }}>
//                     <Typography variant="body2" sx={{ fontSize: "0.85rem" }}>
//                       {booking.faculty_added}
//                       {booking.faculty_limit > 0
//                         ? ` / ${booking.faculty_limit}`
//                         : ""}
//                     </Typography>
//                   </TableCell>
//                   <TableCell sx={{ py: 1.5 }}>
//                     {getStatusChip(booking)}
//                   </TableCell>
//                   <TableCell
//                     onClick={(e) => e.stopPropagation()}
//                     sx={{ py: 1.5 }}
//                   >
//                     {getActionButtons(booking)}
//                   </TableCell>
//                 </TableRow>
//               ))}
//               {paginatedBookings.length === 0 && (
//                 <TableRow>
//                   <TableCell
//                     colSpan={
//                       showTrainer
//                         ? eventType === "fdp"
//                           ? 7
//                           : 6
//                         : eventType === "fdp"
//                         ? 6
//                         : 5
//                     }
//                     align="center"
//                     sx={{ py: 4 }}
//                   >
//                     <Typography color="text.secondary">
//                       No programs found matching your filters
//                     </Typography>
//                   </TableCell>
//                 </TableRow>
//               )}
//             </TableBody>
//           </Table>

//           <TablePagination
//             rowsPerPageOptions={[5, 10, 25, 50]}
//             component="div"
//             count={filteredByHosting.length}
//             rowsPerPage={rowsPerPage}
//             page={page}
//             onPageChange={handleChangePage}
//             onRowsPerPageChange={handleChangeRowsPerPage}
//             sx={{
//               borderTop: "1px solid #e0e0e0",
//               ".MuiTablePagination-toolbar": {
//                 paddingRight: 2,
//               },
//             }}
//           />
//         </TableContainer>
//       )}

//       {/* Menu for actions */}
//       <Menu
//         anchorEl={anchorEl}
//         open={Boolean(anchorEl)}
//         onClose={handleMenuClose}
//         anchorOrigin={{
//           vertical: "bottom",
//           horizontal: "right",
//         }}
//         transformOrigin={{
//           vertical: "top",
//           horizontal: "right",
//         }}
//       >
//         {/* Show existing Add Faculty option */}
//         {selectedBooking && canAddFaculty(selectedBooking) && (
//           <MenuItem onClick={() => handleMenuItemClick("add")}>
//             <ListItemIcon>
//               <Add fontSize="small" sx={{ color: "#4caf50" }} />
//             </ListItemIcon>
//             <ListItemText>Nominate Faculty</ListItemText>
//           </MenuItem>
//         )}

//         {/* Show Add New Faculty only when nomination is open/started and not fully booked */}
//         {selectedBooking && canAddFaculty(selectedBooking) && (
//           <MenuItem onClick={() => handleMenuItemClick("addNew")}>
//             <ListItemIcon>
//               <PersonAdd fontSize="small" sx={{ color: "#FF9800" }} />
//             </ListItemIcon>
//             <ListItemText>Add New Faculty</ListItemText>
//           </MenuItem>
//         )}

//         {/* Always show View Faculty */}
//         <MenuItem onClick={() => handleMenuItemClick("view")}>
//           <ListItemIcon>
//             <Visibility fontSize="small" sx={{ color: "#1976d2" }} />
//           </ListItemIcon>
//           <ListItemText>View Faculty</ListItemText>
//         </MenuItem>

//         {/* Show Download Certificate option only for FDP and when certificate_issue >= 1 */}
//         {selectedBooking &&
//           eventType === "fdp" &&
//           selectedBooking.certificate_issue >= 1 && (
//             <MenuItem
//               onClick={() => handleMenuItemClick("downloadCertificate")}
//             >
//               <ListItemIcon>
//                 <Download fontSize="small" sx={{ color: "#2196F3" }} />
//               </ListItemIcon>
//               <ListItemText>Download Certificate</ListItemText>
//             </MenuItem>
//           )}

//         {/* Show View Coordinators only for FDP events with coordinators */}
//         {selectedBooking &&
//           eventType === "fdp" &&
//           selectedBooking.coordinators &&
//           selectedBooking.coordinators.length > 0 && (
//             <MenuItem
//               onClick={() => {
//                 handleViewCoordinators(
//                   { stopPropagation: () => {} },
//                   selectedBooking.coordinators,
//                   selectedBooking.bookslot_id
//                 );
//                 handleMenuClose();
//               }}
//             >
//               <ListItemIcon>
//                 <Group fontSize="small" sx={{ color: "#4caf50" }} />
//               </ListItemIcon>
//               <ListItemText>View Coordinators</ListItemText>
//             </MenuItem>
//           )}
//       </Menu>

//       {/* Add Faculty Modal */}
//       <AddFacultyModal
//         open={addFacultyModalOpen}
//         onClose={() => setAddFacultyModalOpen(false)}
//         bookslotId={selectedBookslotId}
//         onSuccess={handleAddFacultySuccess}
//       />

//       {/* Add New Faculty Modal (for Nominations Open/Started) */}
//       <AddNewFacultyModal
//         open={addNewFacultyModalOpen}
//         onClose={() => setAddNewFacultyModalOpen(false)}
//         bookslotId={selectedBookslotIdForNew}
//         onSuccess={handleAddFacultySuccess}
//       />

//       {/* View Faculty Modal */}
//       <ViewFacultyModal
//         open={viewFacultyModalOpen}
//         onClose={() => setViewFacultyModalOpen(false)}
//         bookslotId={selectedBookslotIdForView}
//       />

//       {/* View Coordinators Modal */}
//       {eventType === "fdp" && (
//         <ViewCoordinatorsModal
//           open={viewCoordinatorsModalOpen}
//           onClose={() => setViewCoordinatorsModalOpen(false)}
//           coordinators={selectedCoordinators}
//           bookslotId={selectedCoordinatorBookslotId}
//         />
//       )}
//     </Box>
//   );
// };

// export default FacultyEventTable;

import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Chip,
  IconButton,
  TablePagination,
  Tooltip,
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
  CircularProgress,
  useTheme,
  useMediaQuery,
  Card,
  CardContent,
  Stack,
  Divider,
  Link,
  Tabs,
  Tab,
  Button,
  Snackbar,
  Alert,
} from "@mui/material";
import {
  Visibility,
  Add,
  MoreVert,
  PersonAdd,
  Group,
  Download,
  Payment,
  ArrowBack,
  Archive,
  CameraAlt,
  DescriptionOutlined as DocIcon,
} from "@mui/icons-material";
import axios from "axios";
import { BASE_URL } from "../../../../services/configUrls";
import AddFacultyModalFDP from "./AddFacultyModalFDP"; // Updated import for FDP
import AddFacultyModal from "./AddFacultyModal"; // Original for EDP
import AddNewFacultyModal from "./AddNewFacultyModal";
import ViewFacultyModal from "./ViewFacultyModal";
import ViewCoordinatorsModal from "./ViewCoordinatormodal";
import ViewPaymentDetailsModal from "./ViewPaymentDetailsModal";
import RequestProgram from "../RequestFDP";
import InfoOutlined from "@mui/icons-material/InfoOutlined";
import AddNewFacultyModalFDP from "./AddNewFacultyModalFDP";
import AdvanceBookFDPSlots from "../AdvanceBookFDP";
import GeoPhotoUploadModal from "./GeoPhotoUploadModal";
import {
  checkGeoPhotoUploadEligibility,
  isEventWithinEndDate,
  isPrerequisitesViewable,
  checkPrerequisitesViewEligibility
} from "./geoTagWatermarkUtil";
import SpocPrerequisitesDocuments from "../SpocPrerequisitesDocuments";
import DomainPrerequisitesViewModal from "../DomainPrerequisitesViewModal";

const FacultyEventTable = ({
  onBookingClick,
  eventType = "fdp",
  refreshKey,
  activeSubTab,
  onSubTabChange,
  actionButton
}) => {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedBooking, setSelectedBooking] = useState(null);
  const [bookings, setBookings] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [tabValue, setTabValue] = useState(0);
  const [fdpSlotsVisible, setFdpSlotsVisible] = useState(false);
  const [visibilityLoading, setVisibilityLoading] = useState(true);
  const [slotSubTab, setSlotSubTab] = useState("available");

  useEffect(() => {
    if (activeSubTab !== undefined && activeSubTab !== null) {
      setTabValue(activeSubTab);
      if (onSubTabChange) {
        onSubTabChange(null);
      }
    }
  }, [activeSubTab, onSubTabChange]);

  // Add Faculty Modal State
  const [addFacultyModalOpen, setAddFacultyModalOpen] = useState(false);
  const [selectedBookslotId, setSelectedBookslotId] = useState(null);

  // Add New Faculty Modal State
  const [addNewFacultyModalOpen, setAddNewFacultyModalOpen] = useState(false);
  const [selectedBookslotIdForNew, setSelectedBookslotIdForNew] =
    useState(null);

  // View Faculty Modal State
  const [viewFacultyModalOpen, setViewFacultyModalOpen] = useState(false);
  const [selectedBookslotIdForView, setSelectedBookslotIdForView] =
    useState(null);

  // View Coordinators Modal State
  const [viewCoordinatorsModalOpen, setViewCoordinatorsModalOpen] =
    useState(false);
  const [selectedCoordinators, setSelectedCoordinators] = useState([]);
  const [selectedCoordinatorBookslotId, setSelectedCoordinatorBookslotId] =
    useState(null);

  // View Payment Details Modal State (for EDP)
  const [viewPaymentModalOpen, setViewPaymentModalOpen] = useState(false);
  const [selectedPaymentBookslotId, setSelectedPaymentBookslotId] =
    useState(null);
  const [selectedPaymentInstituteId, setSelectedPaymentInstituteId] =
    useState(null);

  // Geo-Tagged Photo Upload Modal State
  const [geoPhotoModalOpen, setGeoPhotoModalOpen] = useState(false);
  const [selectedGeoPhotoBooking, setSelectedGeoPhotoBooking] = useState(null);
  const [toast, setToast] = useState({
    open: false,
    message: "",
    severity: "success"
  });

  const handleUploadGeoPhotos = (booking) => {
    const eligibility = checkGeoPhotoUploadEligibility(booking, eventType);
    if (!eligibility.canUpload) {
      alert(eligibility.message);
      return;
    }
    setSelectedGeoPhotoBooking(booking);
    setGeoPhotoModalOpen(true);
  };

  // Download Banner Modal State
  const [downloadBannerModalOpen, setDownloadBannerModalOpen] = useState(false);
  const [selectedBannerBooking, setSelectedBannerBooking] = useState(null);

  const handleOpenDownloadBanner = (booking) => {
    setSelectedBannerBooking(booking);
    setDownloadBannerModalOpen(true);
  };

  // Domain Prerequisites Modal State
  const [domainPrerequisitesModalOpen, setDomainPrerequisitesModalOpen] =
    useState(false);
  const [selectedPrerequisitesBooking, setSelectedPrerequisitesBooking] =
    useState(null);

  const handleOpenDomainPrerequisites = (booking) => {
    const eligibility = checkPrerequisitesViewEligibility(booking);
    if (!eligibility.canView) {
      alert(eligibility.message);
      return;
    }
    setSelectedPrerequisitesBooking(booking);
    setDomainPrerequisitesModalOpen(true);
  };

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isTablet = useMediaQuery(theme.breakpoints.down("md"));

  const colors = {
    fullyBooked: "#2196F3",
    partiallyBooked: "#9E9E9E",
    upcoming: "#4CAF50",
    started: "#FF9800",
    closed: "#9E9E9E",
    nominationsNotOpen: "#FF5722",
  };

  // Fetch bookings from API
  useEffect(() => {
    console.log("REFRESH KEY TRIGGERED", refreshKey);
    fetchBookings();
  }, [refreshKey]);

  const fetchBookings = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`${BASE_URL}/event/all-bookings`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        },
      });

      const { fdp = [], edp = [] } = response.data;
      const combinedBookings = [...fdp, ...edp];

      setBookings(combinedBookings);
      setError(null);
    } catch (err) {
      setError("Failed to fetch bookings");
      console.error("Error fetching bookings:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const fetchFdpVisibility = async () => {
      try {
        const res = await axios.get(
          `${BASE_URL}/event/institute/fdp-slots-visibility`,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
            },
          },
        );

        setFdpSlotsVisible(res.data?.visible === 1);
      } catch (err) {
        console.error("Failed to fetch FDP slots visibility", err);
        setFdpSlotsVisible(false);
      } finally {
        setVisibilityLoading(false);
      }
    };

    fetchFdpVisibility();
  }, []);

  const formatDate = (dateStr) => {
    return new Date(dateStr).toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
    });
  };

  const getDateRange = (startDate, endDate) => {
    const start = formatDate(startDate);
    const end = formatDate(endDate);
    return start === end ? start : `${start} - ${end}`;
  };

  const isBookingFullyBooked = (booking) => {
    return (
      booking.faculty_limit > 0 &&
      booking.faculty_added >= booking.faculty_limit
    );
  };

  const isBookingPartiallyBooked = (booking) => {
    const hasParticipants = booking.faculty_added > 0;
    return hasParticipants && !isBookingFullyBooked(booking);
  };

  const getStatusChip = (booking) => {
    const getEventStatusChip = () => {
      if (!booking.event_status) return null;

      const statusConfig = {
        Upcoming: { color: colors.upcoming, label: "Upcoming" },
        Started: { color: colors.started, label: "Started" },
        Closed: { color: colors.closed, label: "Closed" },
        "Nominations Not Open": {
          color: colors.nominationsNotOpen,
          label: "Nominations Not Open",
        },
      };

      const config = statusConfig[booking.event_status] || {
        color: colors.closed,
        label: booking.event_status,
      };

      return (
        <Chip
          label={config.label}
          size="small"
          sx={{
            backgroundColor: config.color,
            color: "white",
            fontWeight: 500,
            fontSize: "0.7rem",
          }}
        />
      );
    };

    const getBookingStatusChip = () => {
      if (
        booking.event_status === "Closed" ||
        booking.event_status === "Nominations Not Open"
      ) {
        return null;
      }
      if (
        booking.event_status === "Canceled" ||
        booking.event_status === "Cancelled"
      ) {
        return null;
      }

      if (isBookingFullyBooked(booking)) {
        return null;
      } else if (isBookingPartiallyBooked(booking)) {
        return null;
      } else {
        return null;
      }
    };

    return (
      <Box display="flex" gap={0.5} flexWrap="wrap">
        {getEventStatusChip()}
        {getBookingStatusChip()}
      </Box>
    );
  };

  const handleMenuOpen = (event, booking) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
    setSelectedBooking(booking);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setSelectedBooking(null);
  };

  const handleDownloadCertificate = async (bookslotId) => {
    try {
      const response = await axios.get(
        `${BASE_URL}/event/fdp-institute-certificate/${bookslotId}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
          },
        },
      );

      if (response.data && response.data.certificate_base64) {
        const base64Data = response.data.certificate_base64;
        const byteCharacters = atob(base64Data);
        const byteNumbers = new Array(byteCharacters.length);

        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }

        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: "application/pdf" });

        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = `certificate_${bookslotId}.pdf`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      }
    } catch (err) {
      console.error("Error downloading certificate:", err);
      alert("Failed to download certificate. Please try again.");
    }
  };

  const handleMenuItemClick = (action) => {
    if (action === "add") {
      setSelectedBookslotId(selectedBooking.bookslot_id);
      setAddFacultyModalOpen(true);
      handleMenuClose();
    } else if (action === "addNew") {
      setSelectedBookslotIdForNew(selectedBooking.bookslot_id);
      setAddNewFacultyModalOpen(true);
      handleMenuClose();
    } else if (action === "view") {
      setSelectedBookslotIdForView(selectedBooking.bookslot_id);
      setViewFacultyModalOpen(true);
      handleMenuClose();
    } else if (action === "downloadCertificate") {
      handleDownloadCertificate(selectedBooking.bookslot_id);
      handleMenuClose();
    } else if (action === "paymentSummary") {
      setSelectedPaymentBookslotId(selectedBooking.bookslot_id);
      setSelectedPaymentInstituteId(selectedBooking.institute_id);
      setViewPaymentModalOpen(true);
      handleMenuClose();
    } else if (selectedBooking && onBookingClick) {
      onBookingClick(selectedBooking, action);
      handleMenuClose();
    }
  };

  const handleViewCoordinators = (e, coordinators, bookslotId) => {
    e.stopPropagation();
    setSelectedCoordinators(coordinators || []);
    setSelectedCoordinatorBookslotId(bookslotId);
    setViewCoordinatorsModalOpen(true);
  };

  const handleAddFacultySuccess = () => {
    fetchBookings();
  };

  const canAddFaculty = (booking) => {
    if (!booking?.start_date) return false;

    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const dateStr =
      typeof booking.start_date === "string"
        ? booking.start_date.split("T")[0]
        : "";
    let startDate;
    if (dateStr.includes("-")) {
      const [year, month, day] = dateStr.split("-").map(Number);
      startDate = new Date(year, month - 1, day);
    } else {
      startDate = new Date(booking.start_date);
    }
    startDate.setHours(0, 0, 0, 0);

    // Cannot add/nominate faculty if today > start_date (The FDP has already started)
    const hasNotStarted = isNaN(startDate.getTime())
      ? false
      : today <= startDate;
    const isNotFullyBooked = !isBookingFullyBooked(booking);

    return hasNotStarted && isNotFullyBooked;
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
    setPage(0);
  };

  // Filter bookings by event type
  const filteredByEventType = bookings.filter(
    (booking) => booking.event_type === eventType,
  );

  // Filter by hosted/participated/upcoming
  const filteredByHosting =
    eventType === "fdp"
      ? (() => {
          const nominateData = filteredByEventType.filter((booking) => booking.is_participated === true);
          const participateData = filteredByEventType.filter((booking) => 
            booking.is_upcoming === true &&
            booking.is_hosted !== true &&
            booking.is_participated !== true
          );

          return filteredByEventType.filter((booking) => {
            if (tabValue === (fdpSlotsVisible ? 1 : 0)) {
              return booking.is_hosted === true;
            } else if (tabValue === (fdpSlotsVisible ? 2 : 1)) { // Combined Participate tab
              if (nominateData.length > 0) {
                return booking.is_participated === true;
              } else if (participateData.length > 0) {
                return (
                  booking.is_upcoming === true &&
                  booking.is_hosted !== true &&
                  booking.is_participated !== true
                );
              }
              return false;
            }
            return false;
          });
        })()
      : filteredByEventType.filter((booking) => {
          // EDP: tabValue 0 = Participated, tabValue 1 = Upcoming
          if (tabValue === 0) {
            return booking.is_participated === true;
          } else if (tabValue === 1) {
            return booking.is_upcoming === true;
          }
          return false;
        });

  // Paginate bookings
  const paginatedBookings = filteredByHosting.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage,
  );

  const getActionButtons = (booking) => {
    return (
      <Box display="flex" gap={1} alignItems="center">
        <Tooltip title="More Actions">
          <IconButton
            size="small"
            onClick={(e) => handleMenuOpen(e, booking)}
            sx={{
              color: "#1976d2",
              "&:hover": {
                backgroundColor: "#e3f2fd",
              },
            }}
          >
            <MoreVert />
          </IconButton>
        </Tooltip>
      </Box>
    );
  };

  const MobileCardView = ({ booking, showTrainer }) => {
    return (
      <Card
        sx={{
          mb: 2,
          borderRadius: 3,
          boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
          border: "1px solid #e0e7ff",
          "&:hover": {
            boxShadow: "0 4px 12px rgba(0,0,0,0.12)",
          },
        }}
      >
        <CardContent>
          <Stack spacing={2}>
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="start"
            >
              <Tooltip title={booking.institute_name} arrow>
                <Typography
                  variant="h6"
                  fontWeight={600}
                  sx={{
                    flex: 1,
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    mr: 1,
                  }}
                >
                  {booking.institute_name}
                </Typography>
              </Tooltip>
              <IconButton
                size="small"
                onClick={(e) => handleMenuOpen(e, booking)}
              >
                <MoreVert />
              </IconButton>
            </Box>

            <Divider />

            <Box>
              <Typography variant="caption" color="text.secondary">
                Domain
              </Typography>
              <Tooltip title={booking.domain_name} arrow>
                <Typography
                  variant="body2"
                  sx={{
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    maxWidth: "100%",
                  }}
                >
                  {booking.domain_name}
                </Typography>
              </Tooltip>
            </Box>

            <Box>
              <Typography variant="caption" color="text.secondary">
                Date Range
              </Typography>
              <Typography variant="body2">
                {getDateRange(booking.start_date, booking.end_date)}
              </Typography>
            </Box>

            {showTrainer && (
              <Box>
                <Typography variant="caption" color="text.secondary">
                  Trainer
                </Typography>
                <Typography variant="body2" fontWeight={500}>
                  {booking.trainer_name}
                </Typography>
                <Typography variant="caption" color="text.secondary">
                  {booking.trainer_email}
                </Typography>
              </Box>
            )}

            <Box>
              <Typography variant="caption" color="text.secondary">
                Faculty
              </Typography>
              <Typography variant="body2">
                {booking.faculty_added}
                {booking.faculty_limit > 0 ? ` / ${booking.faculty_limit}` : ""}
              </Typography>
            </Box>

            {eventType === "fdp" &&
              booking.coordinators &&
              booking.coordinators.length > 0 && (
                <Box>
                  <Typography variant="caption" color="text.secondary">
                    Coordinators
                  </Typography>
                  <Link
                    component="button"
                    variant="body2"
                    onClick={(e) =>
                      handleViewCoordinators(
                        e,
                        booking.coordinators,
                        booking.bookslot_id,
                      )
                    }
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 0.5,
                      mt: 0.5,
                      textDecoration: "none",
                      color: "#1976d2",
                      "&:hover": {
                        textDecoration: "underline",
                      },
                    }}
                  >
                    <Group fontSize="small" />
                    View Details ({booking.coordinators?.length || 0})
                  </Link>
                </Box>
              )}

            <Box>{getStatusChip(booking)}</Box>
          </Stack>
        </CardContent>
      </Card>
    );
  };

  if (loading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="400px"
      >
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="400px"
      >
        <Typography color="error">{error}</Typography>
      </Box>
    );
  }

  // Never show trainer for EDP, only for FDP in "Hosted" tab
  const showTrainer = eventType === "fdp" && tabValue === (fdpSlotsVisible ? 1 : 0);

  return (
    <Box sx={{ px: { xs: 2, sm: 3, md: 4 } }}>
      {/* Tabs - Different for FDP and EDP */}
      {eventType === "fdp" ? (
        <>
          <Box sx={{
            borderBottom: 1,
            borderColor: "divider",
            mb: 1,
            display: 'flex',
            flexDirection: { xs: 'column', sm: 'row' },
            justifyContent: 'space-between',
            alignItems: { xs: 'stretch', sm: 'center' },
            gap: { xs: 1.5, sm: 0 }
          }}>
          <Tabs
            value={tabValue}
            onChange={handleTabChange}
            variant="scrollable"
            scrollButtons="auto"
            allowScrollButtonsMobile
            sx={{
              "& .MuiTab-root": {
                textTransform: "none",
                fontSize: { xs: "0.875rem", sm: "1rem" },
                fontWeight: 500,
                minHeight: { xs: 44, sm: 48 },
                px: { xs: 1.5, sm: 2 },
              },
            }}
          >
            {fdpSlotsVisible && (
              <Tab
                label={
                  <Box display="flex" alignItems="center" gap={0.5}>
                    <Typography
                      component="span"
                      sx={{ fontSize: "1rem", fontWeight: 500 }}
                    >
                      Booking Status
                    </Typography>
                    <Tooltip
                      title="View available FDP slots to host & submit interest under Available and also can view Booked slots of all institutes, past submitted FDP interest of all institutes under Archive."
                      arrow
                    >
                      <InfoOutlined
                        fontSize="small"
                        onClick={(e) => e.stopPropagation()}
                        sx={{
                          color: "inherit",
                          cursor: "pointer",
                          ml: 0.25,
                          "&:hover": { color: "primary.main" },
                        }}
                      />
                    </Tooltip>
                  </Box>
                }
                sx={{
                  minHeight: 48,
                  "&.Mui-selected": {
                    color: "primary.main",
                    fontWeight: 600,
                  },
                }}
              />
            )}
            <Tab
              label={
                <Box display="flex" alignItems="center" gap={0.5}>
                  <Typography
                    component="span"
                    sx={{
                      fontSize: "1rem",
                      fontWeight: 500,
                    }}
                  >
                    Host
                  </Typography>
                  <Tooltip
                    title="View Hosted FDPs of your institutes and can nominate your faculties."
                    arrow
                    placement="top"
                  >
                    <InfoOutlined
                      fontSize="small"
                      onClick={(e) => e.stopPropagation()}
                      sx={{
                        color: "inherit",
                        cursor: "pointer",
                        ml: 0.25,
                        "&:hover": {
                          color: "primary.main",
                        },
                      }}
                    />
                  </Tooltip>
                </Box>
              }
              sx={{
                minHeight: 48,
                "&.Mui-selected": {
                  color: "primary.main",
                  fontWeight: 600,
                },
              }}
            />
            <Tab
              label={
                <Box display="flex" alignItems="center" gap={0.5}>
                  <Typography
                    component="span"
                    sx={{
                      fontSize: "1rem",
                      fontWeight: 500,
                    }}
                  >
                    Participate
                  </Typography>
                  <Tooltip
                    title="View FDPs hosting by other institutes and can nominate your faculties."
                    arrow
                    placement="top"
                  >
                    <InfoOutlined
                      fontSize="small"
                      onClick={(e) => e.stopPropagation()}
                      sx={{
                        color: "inherit",
                        cursor: "pointer",
                        ml: 0.25,
                        "&:hover": {
                          color: "primary.main",
                        },
                      }}
                    />
                  </Tooltip>
                </Box>
              }
              sx={{
                minHeight: 48,
                "&.Mui-selected": {
                  color: "primary.main",
                  fontWeight: 600,
                },
              }}
            />
          </Tabs>
          <Box sx={{
            display: 'flex',
            gap: 2,
            alignItems: 'center',
            justifyContent: { xs: 'center', sm: 'flex-end' },
            pr: { xs: 0, sm: 2 },
            pb: { xs: 1, sm: 0 },
            width: { xs: '100%', sm: 'auto' }
          }}>
            {actionButton && <Box sx={{ width: { xs: '100%', sm: 'auto' } }}>{actionButton}</Box>}
          </Box>
        </Box>
        
        {tabValue === 0 && fdpSlotsVisible && slotSubTab === "available" && (
          <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2, mb: 2, pr: 2 }}>
            <Button
              size="small"
              variant="outlined"
              startIcon={<Archive />}
              onClick={() => setSlotSubTab("archive")}
              sx={{
                px: 3,
                fontWeight: 600,
                textTransform: "uppercase",
                color: "#000",
                borderColor: "#000",
                backgroundColor: "transparent",
                boxShadow: "none",
                "&:hover": {
                  backgroundColor: "#1976d2",
                  color: "#ffffff",
                  borderColor: "#1976d2",
                  boxShadow: "0px 2px 4px rgba(0,0,0,0.2)",
                },
              }}
            >
              Archive
            </Button>
          </Box>
        )}
        </>
      ) : (
        // EDP Tabs - Only Participated and Upcoming
        <Box sx={{ borderBottom: 1, borderColor: "divider", mb: 3, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Tabs
            value={tabValue}
            onChange={handleTabChange}
            sx={{
              "& .MuiTab-root": {
                textTransform: "none",
                fontSize: "1rem",
                fontWeight: 500,
              },
            }}
          >
            <Tab
              label={
                <Box display="flex" alignItems="center" gap={0.5}>
                  <Typography
                    component="span"
                    sx={{
                      fontSize: "1rem",
                      fontWeight: 500,
                    }}
                  >
                    Participated
                  </Typography>
                  <Tooltip
                    title="View EDPs where your faculties have participated."
                    arrow
                    placement="top"
                  >
                    <InfoOutlined
                      fontSize="small"
                      onClick={(e) => e.stopPropagation()}
                      sx={{
                        color: "inherit",
                        cursor: "pointer",
                        ml: 0.25,
                        "&:hover": {
                          color: "primary.main",
                        },
                      }}
                    />
                  </Tooltip>
                </Box>
              }
              sx={{
                minHeight: 48,
                "&.Mui-selected": {
                  color: "primary.main",
                  fontWeight: 600,
                },
              }}
            />
            <Tab
              label={
                <Box display="flex" alignItems="center" gap={0.5}>
                  <Typography
                    component="span"
                    sx={{
                      fontSize: "1rem",
                      fontWeight: 500,
                    }}
                  >
                    Upcoming
                  </Typography>
                  <Tooltip
                    title="View upcoming EDPs available for participation."
                    arrow
                    placement="top"
                  >
                    <InfoOutlined
                      fontSize="small"
                      onClick={(e) => e.stopPropagation()}
                      sx={{
                        color: "inherit",
                        cursor: "pointer",
                        ml: 0.25,
                        "&:hover": {
                          color: "primary.main",
                        },
                      }}
                    />
                  </Tooltip>
                </Box>
              }
              sx={{
                minHeight: 48,
                "&.Mui-selected": {
                  color: "primary.main",
                  fontWeight: 600,
                },
              }}
            />
          </Tabs>
          {actionButton && <Box sx={{ pr: 2 }}>{actionButton}</Box>}
        </Box>
      )}

      {!(tabValue === 0 && eventType === "fdp" && fdpSlotsVisible) && (
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          mb={3}
        >
          <Typography
            variant={isMobile ? "body1" : "h6"}
            color="text.secondary"
          >
            {filteredByHosting.length} Programs
          </Typography>
        </Box>
      )}

      {tabValue === 0 && eventType === "fdp" && fdpSlotsVisible ? (
        <Box display="flex" flexDirection="column" gap={0}>
          {slotSubTab === "archive" && (
            <Box display="flex" justifyContent="flex-start" sx={{ mt: -2, mb: -2, position: 'relative', zIndex: 10 }}>
              <IconButton
                onClick={() => setSlotSubTab("available")}
                sx={{ color: "#1976d2" }}
                title="Back"
              >
                <ArrowBack />
              </IconButton>
            </Box>
          )}
          {slotSubTab === "available" ? (
            <AdvanceBookFDPSlots />
          ) : (
            <RequestProgram type="fdp" defaultView="completed" hideToggle={true} />
          )}
        </Box>
      ) : isMobile || isTablet ? (
        // Mobile/Tablet Card View
        <Box>
          {paginatedBookings.map((booking, index) => (
            <MobileCardView
              key={`${booking.bookslot_id}-${index}`}
              booking={booking}
              showTrainer={showTrainer}
            />
          ))}
          {paginatedBookings.length === 0 && (
            <Card sx={{ textAlign: "center", py: 4 }}>
              <Typography color="text.secondary">
                No programs found matching your filters
              </Typography>
            </Card>
          )}
          <TablePagination
            rowsPerPageOptions={[5, 10, 25, 50]}
            component="div"
            count={filteredByHosting.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            sx={{ mt: 2 }}
          />
        </Box>
      ) : (
        // Desktop Table View
        <TableContainer
          component={Paper}
          sx={{
            borderRadius: 3,
            boxShadow: "0 4px 16px rgba(0,0,0,0.08)",
            border: "1px solid #e0e7ff",
            overflowX: "auto",
          }}
        >
          <Table>
            <TableHead>
              <TableRow sx={{ backgroundColor: "#f8fafc" }}>
                {eventType === "fdp" && (
                  <TableCell
                    sx={{ fontWeight: 600, fontSize: "0.8rem", py: 1.5 }}
                  >
                    Hosted Institute
                  </TableCell>
                )}
                <TableCell
                  sx={{ fontWeight: 600, fontSize: "0.8rem", py: 1.5 }}
                >
                  Domain
                </TableCell>
                <TableCell
                  sx={{ fontWeight: 600, fontSize: "0.8rem", py: 1.5 }}
                >
                  Date Range
                </TableCell>
                {showTrainer && (
                  <TableCell
                    sx={{ fontWeight: 600, fontSize: "0.8rem", py: 1.5 }}
                  >
                    Trainer
                  </TableCell>
                )}
                <TableCell
                  sx={{ fontWeight: 600, fontSize: "0.8rem", py: 1.5 }}
                >
                  Faculty
                </TableCell>
                <TableCell
                  sx={{ fontWeight: 600, fontSize: "0.8rem", py: 1.5 }}
                >
                  Status
                </TableCell>
                <TableCell
                  sx={{ fontWeight: 600, fontSize: "0.8rem", py: 1.5 }}
                >
                  Actions
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {paginatedBookings.map((booking, index) => (
                <TableRow
                  key={`${booking.bookslot_id}-${index}`}
                  sx={{
                    "&:hover": {
                      backgroundColor: "#f8fafc",
                    },
                    cursor: "pointer",
                  }}
                  onClick={() => onBookingClick && onBookingClick(booking)}
                >
                  {eventType === "fdp" && (
                    <TableCell sx={{ py: 1.5 }}>
                      <Tooltip title={booking.institute_name} arrow>
                        <Typography
                          variant="body2"
                          sx={{
                            maxWidth: 200,
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                            fontSize: "0.85rem",
                          }}
                        >
                          {booking.institute_name}
                        </Typography>
                      </Tooltip>
                    </TableCell>
                  )}
                  <TableCell sx={{ py: 1.5 }}>
                    <Tooltip title={booking.domain_name} arrow>
                      <Typography
                        variant="body2"
                        sx={{
                          maxWidth: 250,
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                          fontSize: "0.85rem",
                        }}
                      >
                        {booking.domain_name}
                      </Typography>
                    </Tooltip>
                  </TableCell>
                  <TableCell sx={{ py: 1.5 }}>
                    <Typography variant="body2" sx={{ fontSize: "0.85rem" }}>
                      {getDateRange(booking.start_date, booking.end_date)}
                    </Typography>
                  </TableCell>
                  {showTrainer && (
                    <TableCell sx={{ py: 1.5 }}>
                      <Box>
                        <Typography
                          variant="body2"
                          fontWeight={500}
                          sx={{ fontSize: "0.85rem" }}
                        >
                          {booking.trainer_name}
                        </Typography>
                        <Typography
                          variant="caption"
                          color="text.secondary"
                          sx={{ fontSize: "0.75rem" }}
                        >
                          {booking.trainer_email}
                        </Typography>
                      </Box>
                    </TableCell>
                  )}
                  <TableCell sx={{ py: 1.5 }}>
                    <Typography variant="body2" sx={{ fontSize: "0.85rem" }}>
                      {booking.faculty_added}
                      {booking.faculty_limit > 0
                        ? ` / ${booking.faculty_limit}`
                        : ""}
                    </Typography>
                  </TableCell>
                  <TableCell sx={{ py: 1.5 }}>
                    {getStatusChip(booking)}
                  </TableCell>
                  <TableCell
                    onClick={(e) => e.stopPropagation()}
                    sx={{ py: 1.5 }}
                  >
                    {getActionButtons(booking)}
                  </TableCell>
                </TableRow>
              ))}
              {paginatedBookings.length === 0 && (
                <TableRow>
                  <TableCell
                    colSpan={
                      showTrainer
                        ? eventType === "fdp"
                          ? 7
                          : 6
                        : eventType === "fdp"
                          ? 6
                          : 5
                    }
                    align="center"
                    sx={{ py: 4 }}
                  >
                    <Typography color="text.secondary">
                      No programs found matching your filters
                    </Typography>
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>

          <TablePagination
            rowsPerPageOptions={[5, 10, 25, 50]}
            component="div"
            count={filteredByHosting.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            sx={{
              borderTop: "1px solid #e0e0e0",
              ".MuiTablePagination-toolbar": {
                paddingRight: 2,
              },
            }}
          />
        </TableContainer>
      )}

      {/* Menu for actions */}
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        {selectedBooking && canAddFaculty(selectedBooking) && (
          <MenuItem onClick={() => handleMenuItemClick("add")}>
            <ListItemIcon>
              <Add fontSize="small" sx={{ color: "#4caf50" }} />
            </ListItemIcon>
            <ListItemText>Nominate Faculty</ListItemText>
          </MenuItem>
        )}

        {/* Only show "Add New Faculty" for FDP */}
        {eventType === "fdp" &&
          selectedBooking &&
          canAddFaculty(selectedBooking) && (
            <MenuItem onClick={() => handleMenuItemClick("addNew")}>
              <ListItemIcon>
                <PersonAdd fontSize="small" sx={{ color: "#FF9800" }} />
              </ListItemIcon>
              <ListItemText>Add New Faculty</ListItemText>
            </MenuItem>
          )}

        <MenuItem onClick={() => handleMenuItemClick("view")}>
          <ListItemIcon>
            <Visibility fontSize="small" sx={{ color: "#1976d2" }} />
          </ListItemIcon>
          <ListItemText>View Faculty</ListItemText>
        </MenuItem>

        {/* Payment Summary - Only for EDP */}
        {eventType === "edp" && selectedBooking && (
          <MenuItem onClick={() => handleMenuItemClick("paymentSummary")}>
            <ListItemIcon>
              <Payment fontSize="small" sx={{ color: "#9C27B0" }} />
            </ListItemIcon>
            <ListItemText>Payment Summary</ListItemText>
          </MenuItem>
        )}

        {selectedBooking &&
          eventType === "fdp" &&
          selectedBooking.certificate_issue >= 1 && (
            <MenuItem
              onClick={() => handleMenuItemClick("downloadCertificate")}
            >
              <ListItemIcon>
                <Download fontSize="small" sx={{ color: "#2196F3" }} />
              </ListItemIcon>
              <ListItemText>Download Certificate</ListItemText>
            </MenuItem>
          )}

        {selectedBooking &&
          eventType === "fdp" &&
          selectedBooking.coordinators &&
          selectedBooking.coordinators.length > 0 && (
            <MenuItem
              onClick={() => {
                handleViewCoordinators(
                  { stopPropagation: () => {} },
                  selectedBooking.coordinators,
                  selectedBooking.bookslot_id,
                );
                handleMenuClose();
              }}
            >
              <ListItemIcon>
                <Group fontSize="small" sx={{ color: "#4caf50" }} />
              </ListItemIcon>
              <ListItemText>View Coordinators</ListItemText>
            </MenuItem>
          )}

        {/* Download Banner (Posters, Banners, Syllabus Files) - Shown till bookslot end date */}
        {selectedBooking && isEventWithinEndDate(selectedBooking) && (
          <MenuItem
            onClick={() => {
              handleOpenDownloadBanner(selectedBooking);
              handleMenuClose();
            }}
          >
            <ListItemIcon>
              <Download fontSize="small" sx={{ color: "#1877f2" }} />
            </ListItemIcon>
            <ListItemText>Download Banner</ListItemText>
          </MenuItem>
        )}

        {/* Prerequisites (Domain Prerequisites Document) - Shown from 5 days before start date till end date */}
        {selectedBooking && isPrerequisitesViewable(selectedBooking) && (
          <MenuItem
            onClick={() => {
              handleOpenDomainPrerequisites(selectedBooking);
              handleMenuClose();
            }}
          >
            <ListItemIcon>
              <DocIcon fontSize="small" sx={{ color: "#4f46e5" }} />
            </ListItemIcon>
            <ListItemText>Prerequisites</ListItemText>
          </MenuItem>
        )}

        {/* Upload Geo-Tagged Photos */}
        {selectedBooking && (() => {
          const eligibility = checkGeoPhotoUploadEligibility(selectedBooking, eventType);
          const isEligible = eligibility.canUpload;

          return (
            <Tooltip
              title={
                !isEligible
                  ? eligibility.message
                  : eligibility.reminderMessage || "Upload or manage geo-tagged event photos"
              }
              arrow
              placement="left"
            >
              <span>
                <MenuItem
                  disabled={!isEligible}
                  onClick={() => {
                    if (!isEligible) return;
                    handleUploadGeoPhotos(selectedBooking);
                    handleMenuClose();
                  }}
                  sx={{
                    opacity: !isEligible ? 0.6 : 1,
                  }}
                >
                  <ListItemIcon>
                    <CameraAlt
                      fontSize="small"
                      sx={{ color: !isEligible ? "#94a3b8" : "#0284c7" }}
                    />
                  </ListItemIcon>
                  <ListItemText
                    primary="Upload Geo Photos"
                    secondary={
                      !isEligible
                        ? eligibility.shortNotice
                        : undefined
                    }
                    secondaryTypographyProps={{
                      fontSize: "0.72rem",
                      color: "#dc2626",
                      fontWeight: 500,
                    }}
                  />
                </MenuItem>
              </span>
            </Tooltip>
          );
        })()}
      </Menu>

      {/* Add Faculty Modal - FDP uses simplified modal, EDP uses payment modal */}
      {eventType === "fdp" ? (
        <AddFacultyModalFDP
          open={addFacultyModalOpen}
          onClose={() => setAddFacultyModalOpen(false)}
          bookslotId={selectedBookslotId}
          onSuccess={handleAddFacultySuccess}
        />
      ) : (
        <AddFacultyModal
          open={addFacultyModalOpen}
          onClose={() => setAddFacultyModalOpen(false)}
          bookslotId={selectedBookslotId}
          onSuccess={handleAddFacultySuccess}
        />
      )}

      {/* Add New Faculty Modal - Only for FDP */}
      {eventType === "fdp" && (
        <AddNewFacultyModalFDP
          open={addNewFacultyModalOpen}
          onClose={() => setAddNewFacultyModalOpen(false)}
          bookslotId={selectedBookslotIdForNew}
          onSuccess={handleAddFacultySuccess}
        />
      )}

      {/* View Faculty Modal */}
      <ViewFacultyModal
        open={viewFacultyModalOpen}
        onClose={() => setViewFacultyModalOpen(false)}
        bookslotId={selectedBookslotIdForView}
      />

      {/* View Coordinators Modal - Only for FDP */}
      {eventType === "fdp" && (
        <ViewCoordinatorsModal
          open={viewCoordinatorsModalOpen}
          onClose={() => setViewCoordinatorsModalOpen(false)}
          coordinators={selectedCoordinators}
          bookslotId={selectedCoordinatorBookslotId}
        />
      )}

      {/* View Payment Details Modal - Only for EDP */}
      {eventType === "edp" && (
        <ViewPaymentDetailsModal
          open={viewPaymentModalOpen}
          onClose={() => setViewPaymentModalOpen(false)}
          bookslotId={selectedPaymentBookslotId}
          instituteId={selectedPaymentInstituteId}
        />
      )}

      {/* Geo-Tagging Photo Upload Modal */}
      <GeoPhotoUploadModal
        open={geoPhotoModalOpen}
        onClose={() => setGeoPhotoModalOpen(false)}
        booking={selectedGeoPhotoBooking}
        eventType={eventType}
        onSuccess={(res) => {
          fetchBookings();
          setToast({
            open: true,
            message: res?.message?.trim() || "Photos uploaded successfully!",
            severity: "success"
          });
        }}
      />

      {/* Download Banner Modal (SpocPrerequisitesDocuments) */}
      <SpocPrerequisitesDocuments
        open={downloadBannerModalOpen}
        onClose={() => setDownloadBannerModalOpen(false)}
        booking={selectedBannerBooking}
        eventType={eventType}
      />

      {/* Domain Prerequisites Document Modal (View Only) */}
      <DomainPrerequisitesViewModal
        open={domainPrerequisitesModalOpen}
        onClose={() => setDomainPrerequisitesModalOpen(false)}
        booking={selectedPrerequisitesBooking}
        eventType={eventType}
      />

      {/* Toast Feedback */}
      <Snackbar
        open={toast.open}
        autoHideDuration={4000}
        onClose={() => setToast((t) => ({ ...t, open: false }))}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert
          onClose={() => setToast((t) => ({ ...t, open: false }))}
          severity={toast.severity}
          variant="filled"
          sx={{
            width: "100%",
            borderRadius: "8px",
            boxShadow: "0 6px 20px rgba(0,0,0,0.15)",
            fontWeight: 600,
            fontSize: "0.85rem"
          }}
        >
          {toast.message}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default FacultyEventTable;